import { OggiMobile } from './OggiMobile';
import { OggiDesktop } from './OggiDesktop';
import { useIsMobile } from '../../hooks/useIsMobile';

/**
 * Oggi — la home. Computer e telefono sono due pagine diverse con la stessa
 * domanda ("cosa devo fare oggi, e c'è qualcosa che brucia?") e la stessa
 * cache: OggiDesktop (ridisegnata il 26/10/2026) e OggiMobile.
 *
 * La versione del computer di prima (frase lunga, tre numeri, problemi gravi,
 * lavoro in mano a quattro numeri, fatture e pagamenti in due schede, cose da
 * fare in fondo) è copiata in os-planning/ridisegno/prima-del-ridisegno/lavoro.
 */
export function OggiPage() {
  const isMobile = useIsMobile();
  return isMobile ? <div className="page"><OggiMobile /></div> : <OggiDesktop />;
}
